import {ButtonState} from '@fantasmagames/core/src/display/Button';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {Spine} from '@fantasmagames/core/src/spine/Spine';
import {SpinButton} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButton';

export class StopAutoplayButton extends SpinButton {
	protected setState(value: ButtonState): void {
		if (this._state !== value && this._updateManager) {
			this._previousState = this._state;
			this._state = value;

			switch (value) {
				case ButtonState.DISABLED: {
					throw new Error('Disable is impossible state for autoplay button');
				}
				case ButtonState.DOWN: {
					this.stopCurrentAnimation();
					this.stopAdditionalAnimation();
					this.startButtonAnimation('PRESSED', false, true);
					this.onClick();
					break;
				}
				case ButtonState.UP: {
					if (this._previousState === ButtonState.OVER) {
						this.stopAdditionalAnimation();
					} else {
						this.stopCurrentAnimation();
						this.stopAdditionalAnimation();
						this.startButtonAnimation('IDLE', true);
					}

					break;
				}
				case ButtonState.OVER: {
					if (this._previousState === ButtonState.UP) {
						this.stopAdditionalAnimation();
						this.startAdditionalAnimation('HOVER', true);
					} else {
						this.stopCurrentAnimation();
						this.stopAdditionalAnimation();
						this.startButtonAnimation('IDLE', true);
						this.startAdditionalAnimation('HOVER', true);
					}

					break;
				}

				default:
					break;
			}
		}
	}

	protected startButtonAnimation(animationName: string, loop: boolean, dontDestroyOnComplete?: boolean): void {
		this._currentAnimation = new SpineAnimation(
			new Spine(this._resources.getSpine('SPIN_BUTTON_NOGLOW_AUTOPLAY.json')),
			animationName,
			loop,
			dontDestroyOnComplete,
		);
		this._updateManager.add(this._currentAnimation);
		this.addChild(this._currentAnimation.container);
		this._currentAnimation.start();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButton.ts